import { Controller } from "@hotwired/stimulus"

// This controller is used to enable or disable elements using stimulus actions. It disables the element the
// controller is defined on.
export default class extends Controller {
  disable() {
    this.element.disabled = true
  }

  enable() {
    this.element.disabled = false
  }
}
